import { Component, OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioButtonComponent } from '../../../design-system/radio-button/radio-button.component';

@Component({
  selector: 'formly-radio-input',
  templateUrl: "./formly-radio-input.component.html",
  standalone: true,
  imports: [CommonModule, TranslateModule, FormlyModule, ReactiveFormsModule, RadioButtonComponent]
})
export class FormlyRadioComponent extends FieldType implements OnInit, OnDestroy {

  param: any;

  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  fieldKey: string;
  radioConfig = {
    type: 'radio',
    color: 'primary',
    size: 'md',
    options: [
      { id: 11, label: this.translate.instant("Radio 1"), checked: true, class: "w-100pc font-weight-bold" },
      { id: 22, label: this.translate.instant("Radio 2"), checked: false, class: "w-100pc margin-top-20 font-weight-bold" },
      { id: 33, label: this.translate.instant("Radio 3"), checked: false, class: "w-100pc margin-top-20 font-weight-bold" },
      { id: 44, label: this.translate.instant("Radio 4"), checked: false, class: "w-100pc margin-top-20 font-weight-bold" }
    ]
  };

  constructor(
    private dynamicFormService: DynamicFormService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    if (this.field.key) {
      this.fieldKey = this.field.id ?? this.field.key.toString();
    }
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  onValueChange() {
    if (this.to.change) {
      this.to.change(this.field, this.formControl.value);
    }
  }

  sanitizerHtml(element) {
    var safeText = this.sanitizer.bypassSecurityTrustHtml(element);
    return safeText;
  }
}
